<template>
<div>
  <v-data-table
    :headers="headers"
    :items="signatoryList"
    :options.sync="options"
    :server-items-length="totalCount"
    :loading="loading"
    :footer-props="footerProps"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-text-field
            v-model="searchText"
            append-icon="mdi-magnify"
            label="Search"
            color="green darken-2"
            class="mr-2"
            single-line
            hide-details
          ></v-text-field>
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>
    <template v-slot:[`item.EndUser`]="{ item }">
        <span v-if="item.UserID">{{item.EndUser}}</span>
        <span v-else><i>Not yet decided</i></span>
      </template>
      <template v-slot:[`item.Actions`]="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)">
          mdi-pencil
        </v-icon>
      </template>
  </v-data-table>
        <v-dialog
          v-model="Dialog"
          persistent
          max-width="500px"
        >
          <v-card>
            <v-card-title>
              <span class="subtitle-1 font-weight-bold" v-if="editItemId">Update Signatory</span>
              <span class="subtitle-1 font-weight-bold" v-else>New Signatory</span>
              <v-spacer></v-spacer>
              <v-btn
                    icon
                    dark
                    color="secondary2"
                    @click="cancel()"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
            </v-card-title>
              <v-form @submit.prevent ref="formRef">
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                          v-model="formData.UserID"
                          label="Designated Person"
                          :rules="[formRules.required]"
                          color="header"
                          :items="users"
                          item-text="description"
                          item-value="id"
                          type="text"
                        ></v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                    dense
                     v-model="formData.Title"
                     :rules="[formRules.required]"
                     counter
                     maxlength="50"
                     color="header"
                      label="Title / Designation"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
             </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="grey darken-1"
                outlined
                @click="cancel()"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-1"
                dark
                @click="update"
                :loading="isLoading"
              >
              <v-icon class="mr-1">mdi-pencil-box</v-icon>
                Update
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      <fade-away-message-component
			displayType="variation2"
			v-model="fadeAwayMessage.show" 
			:message="fadeAwayMessage.message" 
			:header="fadeAwayMessage.header" 
			:top="fadeAwayMessage.top"
			:type="fadeAwayMessage.type"
		></fade-away-message-component>
  </div>
</template>

<script>
  export default {
    data: () => ({
      searchText: '',
      editItemId: null,
      footerProps: {'items-per-page-options': [5, 10, 20, 50, 100, 500]},
      totalCount: 0,
      loading: true,
      options: {},
      fadeAwayMessage : {
			show : false,
			type : 'success',
			header : 'Successfully Saved!',
			message : '',
			top : 10
		},
      isLoading: false,
      formData: {
        UserID: null,
        Title: null,
      },
      Dialog: false,
      postionList: [],
      headers: [
        {
          text: 'Document Type',
          align: 'start',
          sortable: false,
          value: 'DocType',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Title/Designation',
          align: 'start',
          sortable: false,
          value: 'Title',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'User',
          align: 'start',
          sortable: false,
          value: 'EndUser',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Role',
          align: 'start',
          sortable: false,
          value: 'RoleDescription',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Date Created',
          align: 'start',
          sortable: false,
          value: 'DateCreated',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        { text: 'Actions', value: 'Actions', sortable: false, width: '100', class: "green darken-2 white--text text-caption font-weight-bold" },
      ],
      users: [],
    }),
    watch: {
      options: {
        handler () {
         this.initialize();
        },
        deep: true,
      },
      searchText: {
        handler () {
         this.initialize();
        },
        deep: true,
      },
    },
    created () {
      this.getAllSignatorys();
    },
    methods: {
      cancel() {
        this.editItemId = null;
        this.$refs.formRef.reset();
        this.Dialog = false;
      },
      initialize () {
        this.loading = true
         let data = new FormData();
         if(this.options.page){
              data.append('page', this.options.page);
              data.append('itemsPerPage', this.options.itemsPerPage);
         }else{
              data.append('page', 1);
              data.append('itemsPerPage', 10);
         }
         data.append("searchText", this.searchText);
              this.axiosCall(
              '/getSignatory',
              'POST',
              data
          )
          .then((res) => {
            this.loading = false
              this.signatoryList = res.data.data.result;
              this.users = res.data.data.users;
              this.totalCount = res.data.data.total;
              if(this.totalCount <= 10){
                this.options.page = 1;
              }
          })
      },
    editItem(data) {
      this.editItemId = data.SignatoryID;
      this.formData.UserID = data.UserID;
      this.formData.Title = data.Title;
      this.Dialog = true;
		},
      update () {
         if(this.$refs.formRef.validate()){
              this.isLoading = true;
              let data = new FormData();
              data.append('SignatoryID', this.editItemId);
              data.append('UserID', this.formData.UserID);
              data.append('Title', this.formData.Title);
                         this.axiosCall(
                        '/signatory/edit',
                        'POST',
                        data
                    )
                    .then((res) => {
                        this.isLoading = false;
                        if(res.data.status) {
                        this.fadeAwayMessage.show = true;
                        this.fadeAwayMessage.type = 'success';
                        this.fadeAwayMessage.message = 'Signatory was successfully updated!!';
                        this.fadeAwayMessage.header = 'System Message';
                        this.$refs.formRef.reset();
                        this.Dialog = false;
                        this.editItemId = null;
                         this.initialize();
                        }else {
                        this.fadeAwayMessage.show = true;
                        this.fadeAwayMessage.type = 'error';
                        this.fadeAwayMessage.message = 'Something went wrong try again!';
                        this.fadeAwayMessage.header = 'System Message';
                        }
                    })
         }
      },
    }
  }
</script>